import { render, staticRenderFns } from "./ReplacementRuleTable.vue?vue&type=template&id=87a46a90&scoped=true"
import script from "./ReplacementRuleTable.vue?vue&type=script&lang=js"
export * from "./ReplacementRuleTable.vue?vue&type=script&lang=js"
import style0 from "./ReplacementRuleTable.vue?vue&type=style&index=0&id=87a46a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a46a90",
  null
  
)

export default component.exports